//-------------------------------------------------------------------------------
// Four HOCs so every component can consume wrappers to connect to the store,
// translations, register all loaded instances of ag-grid to force a re-render,
// or bring a component into the dedicated modal box wrapper.
//
// Load Polyfills before rendering the app (promise-based).
//
// Attach React to #ifg-root.
//
// Scoped stylesheet contains global-level basic styles for all tags and for the
// app container that is not displayed on load. Vanilla js takes care of it in sagas --------- XXXXX >>>>>>
// --------- XXXXX >>>>>> HAS TO BE REVIEWED CAUSE I THINK IT SHOULD BE MANAGED BY REACT ---- THE WHOLE PRELOADER
// THINGY HAS TO BE REVIEWED.
//-------------------------------------------------------------------------------

//-------------------------------------------------------------------------------
// Import Directives
//-------------------------------------------------------------------------------

import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { I18nextProvider } from 'react-i18next';
import i18n from '@/assets/js/utilities/i18n.config';

import { Provider } from 'react-redux';
import { store } from '@/js/stateManagement/createStore';
import { APIManagementActions } from '@/js/stateManagement/APIManagement';
import { API_ALL_FLAVOR } from '@/js/utilities/apiCallsList';

import AgGridProvider from '@/assets/js/components/agGrid/context/Provider';

import ModalBoxProvider from '@/assets/js/components/modalBox/context/Provider';
import ThemeProvider from '@/assets/js/components/themeContext/ThemeProvider';

import './main.scss';
const IFGUniversalPortal = lazy(() => import('./components/IFGUniversalPortal'));

//-------------------------------------------------------------------------------
// Note: ag-grid module registration and the Enterprise license key now live in
// agGrid/registerAgGrid.js, imported by the lazily-loaded grid table components,
// so the ag-grid bundle stays out of this entry chunk.
//-------------------------------------------------------------------------------
// React Render Call in a promise with browser sniffing first in order
// to load polyfills if needed. HOC for redux-connect, react-i18next,
// ag-grid, and a modal box.
//
//-------------------------------------------------------------------------------

// An ALB redirect cannot name a hash route, so the withdrawme vanity domain
// lands here as '/?redirect=gdpr'. A restorable session opens that page
// directly; anyone else signs in and the login form sends them on.
// grep/ca7996e06c3553a737a8b660750354e2
const landingRedirect = new URLSearchParams(window.location.search).get('redirect');
if (landingRedirect && !window.location.hash) {
  const target = encodeURIComponent(landingRedirect);
  const route = localStorage.getItem('refreshToken') ? target : `login?redirect=${target}`;
  window.history.replaceState(null, '', `/#/${route}`);
}

// /v0/flavor is the single oracle for the deployment flavor, resolved before
// the first render: the store is hydrated so no component refetches it, and the
// answer decides whether the whole tree runs under StrictMode (non-prod only).
// A failure here leaves the app with no flavor to build partner/SSO URLs from,
// so there is nothing to render -- surface it and stop.
const bootstrap = async () => {
  let flavor;
  try {
    const response = await fetch(API_ALL_FLAVOR.path);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    flavor = await response.json();
  } catch (error) {
    console.error('error', error);
    window.alert('We are unable to start the application right now. Please try again later.');
    return;
  }

  store.dispatch(APIManagementActions.setFlavor(flavor));

  const tree = (
    <Suspense fallback="">
      <I18nextProvider i18n={i18n}>
        <Provider store={store}>
          {/* <PersistGate loading={null} persistor={persistor}> */}
          <AgGridProvider>
            <ModalBoxProvider>
              <ThemeProvider>
                <IFGUniversalPortal />
              </ThemeProvider>
            </ModalBoxProvider>
          </AgGridProvider>
          {/* </PersistGate> */}
        </Provider>
      </I18nextProvider>
    </Suspense>
  );

  const root = createRoot(document.getElementById('ifg-root'));
  const devFlavor = ['dev', 'transient', 'preview0'].includes(flavor.flavor);
  root.render(devFlavor ? <StrictMode>{tree}</StrictMode> : tree);
};

bootstrap();
